import { Routes } from '@angular/router';
import { HolidaysComponent } from './holidays/holidays.component';
import { HowzitComponent } from './howzit/howzitcomponent';
import { RewardsComponent } from './rewards/rewards.component';

export default [
    {
        path: 'xl-holidays',
        component: HolidaysComponent,
    },
    {
        path: 'xl-howzit',
        component: HowzitComponent
    },
    {
        path: 'rewards-page',
        component: RewardsComponent
    }
    
] as Routes;
